// extracted by mini-css-extract-plugin
module.exports = {"power-backup-F":"F_power-backup-F__y54gJ"};